
import { createPublicClient } from "viem"
import { http, createConfig, WagmiProvider } from 'wagmi'
import { injected, metaMask, walletConnect } from 'wagmi/connectors'
import { getWagmiConnectorV2 } from '@binance/w3w-wagmi-connector-v2'
import { bsc, mainnet, bscTestnet } from 'wagmi/chains'

const connector = getWagmiConnectorV2()

const wagmiConfig = createConfig({
    chains: [bsc, bscTestnet],
    connectors: [
        metaMask({
            dappMetadata: {
                name: "StarAI",
                // url: import.met,
                // iconUrl: "https://wagmi.io/favicon.ico",
            },
        }),
        injected({
            target: "OKX Wallet"
        }),
        walletConnect({ 
            projectId: 'e9013a68e5c6ad46a75c3dea38a7f849',
            showQrModal: true,
            qrModalOptions: {
                themeVariables: {
                    '--wcm-z-index': '2010', // 直接设置 CSS 变量
                },
            },
        }),
        connector()
    ],
    // publicClient: createPublicClient({
    //     chain: bsc,
    //     transport: http(),
    // }),
    transports: {
        // [mainnet.id]: http(),
        [bsc.id]: http(),
        [bscTestnet.id]: http(),
    },
})

export default wagmiConfig;

